(function(){
  if(window.LollensteinChargenpassInfoInitialized) return;
  window.LollensteinChargenpassInfoInitialized=true;

  var modal=null;
  var lastTrigger=null;

  function buildModal(){
    if(modal) return modal;
    modal=document.createElement('div');
    modal.className='pp-info-modal';
    modal.setAttribute('aria-hidden','true');
    modal.innerHTML=''
      +'<div class="pp-info-modal__backdrop" data-pp-info-close></div>'
      +'<div class="pp-info-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="pp-info-modal-title" tabindex="-1">'
      +'<div class="pp-info-modal__header">'
      +'<h2 class="pp-info-modal__title" id="pp-info-modal-title"></h2>'
      +'<button type="button" class="pp-info-modal__close" aria-label="Erklärung schließen" data-pp-info-close>&times;</button>'
      +'</div>'
      +'<div class="pp-info-modal__body">'
      +'<p class="pp-info-modal__short" data-pp-modal-short></p>'
      +'<p class="pp-info-modal__long" data-pp-modal-long></p>'
      +'<div class="pp-info-modal__footer">'
      +'<span class="pp-info-modal__hint">Erklärung aus dem Lollenstein Futterlexikon</span>'
      +'<a class="pp-info-modal__link" href="/pages/futterlexikon" data-pp-modal-link>Im Futterlexikon weiterlesen →</a>'
      +'</div></div></div>';
    document.body.appendChild(modal);
    modal.addEventListener('click',function(e){if(e.target.closest('[data-pp-info-close]')) closeModal();});
    return modal;
  }

  function getText(source,selector){
    var el=source?source.querySelector(selector):null;
    return el?el.textContent.trim():'';
  }

  function openModal(trigger){
    var source=trigger.parentElement?trigger.parentElement.querySelector('[data-pp-info-source]'):null;
    if(!source) return;
    var m=buildModal();
    var title=getText(source,'[data-pp-info-title]');
    var shortText=getText(source,'[data-pp-info-short]');
    var longText=getText(source,'[data-pp-info-long]');
    var anchor=getText(source,'[data-pp-info-anchor]');
    m.querySelector('#pp-info-modal-title').textContent=title;
    var shortEl=m.querySelector('[data-pp-modal-short]');
    var longEl=m.querySelector('[data-pp-modal-long]');
    shortEl.textContent=shortText;
    shortEl.hidden=!shortText;
    longEl.textContent=longText;
    longEl.hidden=!longText;
    var link=m.querySelector('[data-pp-modal-link]');
    link.href='/pages/futterlexikon'+(anchor?'#'+encodeURIComponent(anchor):'');
    lastTrigger=trigger;
    m.classList.add('is-open');
    m.setAttribute('aria-hidden','false');
    document.documentElement.classList.add('pp-info-modal-open');
    document.body.classList.add('pp-info-modal-open');
    window.setTimeout(function(){var close=m.querySelector('.pp-info-modal__close');if(close)close.focus();},0);
  }

  function closeModal(){
    if(!modal||!modal.classList.contains('is-open')) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden','true');
    document.documentElement.classList.remove('pp-info-modal-open');
    document.body.classList.remove('pp-info-modal-open');
    if(lastTrigger&&document.contains(lastTrigger)) lastTrigger.focus();
    lastTrigger=null;
  }

  function trapFocus(e){
    if(!modal||!modal.classList.contains('is-open')||e.key!=='Tab') return;
    var focusable=modal.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])');
    if(!focusable.length) return;
    var first=focusable[0],last=focusable[focusable.length-1];
    if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
    else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
  }

  document.addEventListener('click',function(e){
    var trigger=e.target.closest('[data-pp-info-trigger]');
    if(trigger){e.preventDefault();openModal(trigger);}
  });
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape') closeModal();
    trapFocus(e);
  });
})();
